var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 25.3334V22.6667H7.99999V13.3334C7.99999 11.4889 8.55555 9.85002 9.66666 8.41669C10.7778 6.98335 12.2222 6.04446 14 5.60002V4.66669C14 4.11113 14.1944 3.63891 14.5833 3.25002C14.9722 2.86113 15.4444 2.66669 16 2.66669C16.5556 2.66669 17.0278 2.86113 17.4167 3.25002C17.8056 3.63891 18 4.11113 18 4.66669V5.60002C19.7778 6.04446 21.2222 6.98335 22.3333 8.41669C23.4444 9.85002 24 11.4889 24 13.3334V22.6667H26.6667V25.3334H5.33333ZM16 29.3334C15.2667 29.3334 14.6389 29.0722 14.1167 28.55C13.5944 28.0278 13.3333 27.4 13.3333 26.6667H18.6667C18.6667 27.4 18.4056 28.0278 17.8833 28.55C17.3611 29.0722 16.7333 29.3334 16 29.3334Z",
    fill: "#BABCBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInactive);
export default __webpack_public_path__ + "static/media/AlertInactive.c3d8e37664f0c9cd58765962d20d2191.svg";
export { ForwardRef as ReactComponent };